<template>
	<div
		:id="`cta-box-${_uid}`"
		class="c-block-list-cta-box-custom c-block-list-cta-box-custom--wide"
	>
		<LongReadTarget
			:container-id="`cta-box-${_uid}`"
			:title="title"
			:disabled="!title || !title.length"
		>
			<div
				v-if="image || title || teaser || link[0]"
				class="-mx-layout-margin px-layout-margin bg-secondary"
			>
				<!-- Content -->
				<div
					:class="[
						'flex flex-col justify-center items-center space-y-sm',
						'>=768:flex-row >=768:space-x-layout-gutter >=768:space-y-0',
						{ 'py-lg': image },
						{ 'py-xl': !image },
					]"
				>
					<!-- Image -->
					<div v-if="image" class="flex-1 w-6col">
						<UmbracoImageExt
							:alt="image.altText"
							:source-url="image.cropUrl || image.url"
							:source-width="image.width"
							:source-height="image.height"
							:widths="[
								320,
								417,
								768,
								1024,
								1920,
								1024 * 2,
								1920 * 2,
							]"
							:aspect-ratio="8 / 5"
							class="w-full rounded-md overflow-hidden"
						/>
					</div>

					<!-- Content -->
					<div
						:class="[
							'flex flex-col justify-center w-6col >=768:px-1col',
							{ 'items-center text-center': !image },
						]"
					>
						<div :class="{ 'max-w-488': image }">
							<BaseH1
								v-if="title"
								tag="h2"
								class="mb-sm"
								v-text="title"
							/>

							<p v-if="teaser" class="mb-md" v-html="teaser"></p>

							<NuxtLinkExt
								v-if="link && link[0]"
								:class="['block w-fit', { 'mx-auto': !image }]"
								:to="link[0].url"
								:target="link[0].target"
							>
								<BaseButton class="w-fit" tag="div">
									<template #default>
										{{ linktext || link[0].name }}
									</template>

									<template #icon>
										<SvgArrow
											v-if="link[0].type === 'url'"
											class="transform -rotate-45"
										/>
									</template>
								</BaseButton>
							</NuxtLinkExt>
						</div>
					</div>
				</div>
			</div>
		</LongReadTarget>
	</div>
</template>

<script>
import UmbracoImageExt from '~/components/shared/UmbracoImageExt';
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';
import SvgArrow from '~/assets/svgs/arrow-icon.svg?inline';

export default {
	name: 'BlockListCtaBoxCustom',
	components: { UmbracoImageExt, LongReadTarget, SvgArrow },
	inheritAttrs: false,

	props: {
		title: {
			type: String,
			required: false,
		},
		teaser: {
			type: String,
			required: false,
		},
		image: {
			type: Object,
			required: false,
		},
		linktext: {
			type: String,
			required: false,
		},
		link: {
			type: Array,
			required: true,
		},
	},
};
</script>
